import 'css-chunksrc/client/pages/projectPage/resourcesPage/filters/sortDropDown/dropDownInput/styles.scss';export default {
  "dropDownInput": "_dropDownInput_a3aai_1",
  "opened": "_opened_a3aai_18",
  "icon": "_icon_a3aai_23"
};